<app-showcase></app-showcase>
<app-announcements></app-announcements>
<app-about-us></app-about-us>
<app-courses></app-courses>
<app-vacancy></app-vacancy>
<app-news></app-news>
<app-why-choose-us></app-why-choose-us>
<app-facilities></app-facilities>
<app-testimonials></app-testimonials>